import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logo from './logo.png';
// import 'utils.js';
const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  const validateForm = () => {
    const formErrors = {};
    if (!username) formErrors.username = "Username is required";
    if (!password) formErrors.password = "Password is required";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (validateForm()) {
      try {
        const response = await axios.post(
          "https://ims-backend.indevconsultancy.in/api/login/",
          {
            user_name: username,
            password,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = response.data;

        if (data.user) {
          localStorage.clear();
          localStorage.setItem("user", JSON.stringify(data.user));
          localStorage.setItem("kitchen_id", data.user.kitchen);
          localStorage.setItem("role_name", data.user.role);

          if (data.user.role === "admin") {
            navigate("/dashboard");
          } else if (data.user.role === "kitchen") {
            navigate("/mobilehome");
          } else if (data.user.role === "project") {
            navigate("/ProjectAdminKitchen");
          } else if (data.user.role === "purchase") {
            localStorage.setItem("user", JSON.stringify(data.user));
            localStorage.setItem("user_id", data.user.user_id);
            localStorage.setItem("user_name", data.user.user_name);
            localStorage.setItem("role_name", data.user.role);
            navigate("/purchaseDashboard");
          } else {
            setErrorMsg("Unknown role. Cannot redirect.");
          }
        } else {
          setErrorMsg("Login failed. Invalid credentials.");
        }
      } catch (error) {
        if (error.response) {
          console.error("Error response:", error.response.data);
          setErrorMsg(
            error.response.data.detail ||
            error.response.data.error ||
            "Login failed. Invalid credentials."
          );
        } else {
          console.error("Network or other error:", error);
          setErrorMsg("Something went wrong. Please try again later.");
        }
      }
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="col-11 col-sm-10 col-md-5 px-2 px-sm-0 py-3">
        <div className="row justify-content-center g-0">
          <div className="col-lg-9 col-xl-8 col-xxl-6">
            <div className="card shadow">
              <div className="card-header text-center p-2 bg-white border-bottom">
                <img src={logo} alt="logo" style={{ maxWidth: "120px" }} />
              </div>
              <div className="card-body p-4">
                <form onSubmit={handleSubmit}>
                  {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}

                  <div className="mb-3">
                    <label className="form-label">Username</label>
                    <input
                      className={`form-control ${errors.username ? "is-invalid" : ""}`}
                      type="text"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                    {errors.username && <div className="invalid-feedback">{errors.username}</div>}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Password</label>
                    <input
                      className={`form-control ${errors.password ? "is-invalid" : ""}`}
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                  </div>

                  <div className="mb-3">
                    <button className="btn btn-primary w-100" type="submit">
                      Log in
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
